import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { getClubTimezone } from '@jupi/ui'

dayjs.extend(utc)
dayjs.extend(timezone)

// Every time a member reads or types is club wall-clock time, whatever zone the
// browser is in (a pilot abroad still books Finnish time). These convert at
// that boundary.

// "2026-06-01" and "10:30" for an instant, as the booking API takes them.
export function clubParts(instant: string | Date): { date: string; time: string } {
  const local = dayjs(instant).tz(getClubTimezone())
  return { date: local.format('YYYY-MM-DD'), time: local.format('HH:mm') }
}

// The instant for a club date and time, as an ISO string.
export function clubInstant(date: string, time: string): string {
  return dayjs.tz(`${date} ${time}`, getClubTimezone()).toISOString()
}

// The club's YYYY-MM-DD for today.
export function clubToday(): string {
  return dayjs().tz(getClubTimezone()).format('YYYY-MM-DD')
}
